module.exports = __webpack_public_path__ + "img/no_posh.f2d2dd44.svg";